export default __webpack_public_path__ + "static/media/pv-tcho.22fdcec7.jpg";